/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
import React from "react";
import { CircleNotch } from "phosphor-react";

export const Loading = () => (
  <div
    style={{
      width: "1.5rem", 
      height: "1.5rem", 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center", 
      overflow: "hidden" 
    }}
  >
    <CircleNotch
      weight="bold"
      style={{
        width: "1rem", 
        height: "1rem", 
        animation: "spin 1s linear infinite" 
      }}
    />
  </div>
);

const style = document.createElement("style");
style.innerHTML = `
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
document.head.appendChild(style);
